import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/index';

class PageChangeHandler extends Component {
  componentDidUpdate() {
    this.props.LogCurrentPath(this.props.history.location.pathname)
    // Cause changes to the app when the path changes
    if ((this.props.currentPath && this.props.prevPath) && (this.props.currentPath !== this.props.prevPath)) {
      if (this.props.showUserMenu) {
        this.props.ToggleUserMenu('close');
      }

      if (this.props.authError) {
        this.props.ClearAuthError()
      }
    }
  }
  render() {
    return this.props.children
  }
}

const mapStateToProps = (state) => {
  return {
    currentPath: state.global.currentPath,
    prevPath: state.global.prevPath,
    showUserMenu: state.global.showUserMenu,
    authError: state.auth.error
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    LogCurrentPath: (path) => dispatch(actionCreators.logCurrentPath(path)),
    ToggleUserMenu: (toggleAction) => dispatch(actionCreators.toggleUserMenu(toggleAction)),
    ClearAuthError: () => dispatch(actionCreators.clearAuthError())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageChangeHandler));


// WEBPACK FOOTER //
// ./src/hoc/PageChangeHandler/PageChangeHandler.jsx